import React, {
  useEffect,
  createContext,
  useContext,
  useState,
  useCallback,
} from "react";
import { getBeyondContract } from "../utils/etherutils";

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [library, setAuthLibrary] = useState();
  const [account, setAuthAccount] = useState();
  const bigBeyondContract = useCallback(() => {
    if (library && account) {
      return getBeyondContract(library, account);
    }
  }, [account, library]);

  const [expiresAt, setExpiresAt] = useState(localStorage.getItem("expiresAt"));

  const [authToken, setAuthToken] = useState(
    Boolean(expiresAt) && new Date().getTime() < expiresAt
      ? localStorage.getItem("auth-token") || ""
      : ""
  );

  useEffect(() => {
    if (authToken) {
      localStorage.setItem("auth-token", authToken);
      const newExpiresAt = new Date().getTime() + 24 * 60 * 60 * 1000;
      setExpiresAt(newExpiresAt);
      localStorage.setItem("expiresAt", newExpiresAt);
    } else {
      localStorage.setItem("auth-token", "");
      localStorage.setItem("expiresAt", null);
    }
  }, [authToken]);

  const authTokenChangeHandler = (newAuthToken) => {
    setAuthToken(newAuthToken);
  };

  return (
    <AuthContext.Provider
      value={{
        authToken,
        setAuthToken: authTokenChangeHandler,
        bigBeyondContract,
        library,
        setAuthLibrary,
        account,
        setAuthAccount,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuthContext must be used within a AuthContextProvider");
  }
  return context;
};
